import { v4 } from '@lukeed/uuid';
import { original } from 'immer';
import { xFindClosestIndex } from 'ml-spectra-processing';
import { getShiftX, lookupPeak, autoPeakPicking, optimizePeaks, } from '../../../data/data1d/Spectrum1D';
import { defaultPeaksViewState } from '../../hooks/useActiveSpectrumPeaksViewState';
import { getActiveSpectrum } from '../helper/getActiveSpectrum';
import getRange from '../helper/getRange';
//action
function handleAddPeak(draft, action) {
    const { x: mouseXPosition } = action.payload;
    const activeSpectrum = getActiveSpectrum(draft);
    const state = original(draft);
    if (activeSpectrum?.id && state) {
        const { index } = activeSpectrum;
        const xShift = 10;
        const startX = mouseXPosition - xShift;
        const endX = mouseXPosition + xShift;
        const [from, to] = getRange(draft, { startX, endX });
        const candidatePeak = lookupPeak(state.data[index].data, {
            from,
            to,
        });
        const shiftX = getShiftX(draft.data[index]);
        if (candidatePeak) {
            const peak = {
                id: v4(),
                originalX: candidatePeak.x - shiftX,
                x: candidatePeak.x,
                y: candidatePeak.y,
                width: 0,
            };
            draft.data[index].peaks.values.push(peak);
        }
    }
}
//action
function handleAddPeaks(draft, action) {
    const state = original(draft);
    const activeSpectrum = getActiveSpectrum(draft);
    if (activeSpectrum) {
        const { index } = activeSpectrum;
        const datumOriginal = state.data[index];
        const { startX, endX } = action.payload;
        const [from, to] = getRange(draft, { startX, endX });
        if (from !== to) {
            const peak = lookupPeak(datumOriginal.data, { from, to });
            const shiftX = getShiftX(draft.data[index]);
            if (peak && !datumOriginal.peaks.values.some((p) => p.x === peak.x)) {
                const newPeak = {
                    id: v4(),
                    originalX: peak.x - shiftX,
                    x: peak.x,
                    y: peak.y,
                    width: 0,
                };
                draft.data[index].peaks.values.push(newPeak);
            }
        }
    }
}
//action
function handleDeletePeak(draft, action) {
    const activeSpectrum = getActiveSpectrum(draft);
    const peakId = action?.payload?.id;
    if (activeSpectrum) {
        const { index } = activeSpectrum;
        const state = original(draft);
        if (!peakId) {
            draft.data[index].peaks.values = [];
        }
        else {
            const peakIndex = state.data[index].peaks.values.findIndex((p) => p.id === peakId);
            draft.data[index].peaks.values.splice(peakIndex, 1);
        }
    }
}
//action
function handleOptimizePeaks(draft, action) {
    const { peaks } = action.payload;
    const activeSpectrum = getActiveSpectrum(draft);
    if (activeSpectrum?.id) {
        const { index } = activeSpectrum;
        const datum = draft.data[index];
        const [from, to] = draft.xDomain;
        const newPeaks = optimizePeaks(draft.data[index], {
            from,
            to,
            peaks,
        });
        datum.peaks.values = newPeaks;
    }
}
//action
function handleAutoPeakPicking(draft, action) {
    const { maxNumberOfPeaks, minMaxRatio, noiseFactor, direction } = action.payload;
    const activeSpectrum = getActiveSpectrum(draft);
    if (activeSpectrum?.id) {
        draft.toolOptions.selectedTool = 'zoom';
        draft.toolOptions.selectedOptionPanel = null;
        const { index } = activeSpectrum;
        const datum = draft.data[index];
        const [from, to] = draft.xDomain;
        const windowFromIndex = xFindClosestIndex(datum.data.x, from);
        const windowToIndex = xFindClosestIndex(datum.data.x, to);
        const peaks = autoPeakPicking(draft.data[index], {
            maxNumberOfPeaks,
            minMaxRatio,
            noiseFactor,
            direction,
            windowFromIndex,
            windowToIndex,
        });
        datum.peaks.values = datum.peaks.values.concat(peaks);
    }
}
//action
function handleChangePeakShape(draft, action) {
    const { shape, id } = action.payload;
    const activeSpectrum = getActiveSpectrum(draft);
    if (activeSpectrum?.id) {
        const { index } = activeSpectrum;
        const datum = draft.data[index];
        const peakIndex = datum.peaks.values.findIndex((peak) => peak.id === id);
        if (peakIndex !== -1) {
            datum.peaks.values[peakIndex].shape = shape;
        }
    }
}
//action
function handleTogglePeaksViewProperty(draft, action) {
    const { key } = action.payload;
    togglePeaksViewProperty(draft, key);
}
function togglePeaksViewProperty(draft, key) {
    const activeSpectrum = getActiveSpectrum(draft);
    if (activeSpectrum?.id) {
        const peaksView = draft.view.peaks;
        if (peaksView[activeSpectrum.id]) {
            peaksView[activeSpectrum.id][key] = !peaksView[activeSpectrum.id][key];
        }
        else {
            const defaultPeaksView = { ...defaultPeaksViewState };
            defaultPeaksView[key] = !defaultPeaksView[key];
            peaksView[activeSpectrum.id] = defaultPeaksView;
        }
    }
}
export { handleAddPeak, handleAddPeaks, handleDeletePeak, handleAutoPeakPicking, handleOptimizePeaks, handleChangePeakShape, handleTogglePeaksViewProperty, };
